export const setDirection = () => {
  const direction = document.documentElement.getAttribute('dir');

  return direction === 'rtl' ? 'rtl' : 'ltr';
};
